angular.module('leanlaw').service('matterClientService', function () {
  this.initials = person => {
    if (!person) return '';
    if (person.initials) return person.initials;
    let {
      first,
      last
    } = person;
    if (first && last) {
      return `${first[0]}${last[0]}`;
    } else {
      const names = person.name.split(' ');
      first = names[0];
      last = names[names.length - 1];
      return `${first[0]}${last[0]}`;
    }
  };
});